<template>
	<div class="">
		<div class="watermark absolute w-full h-full top-0 left-0 bg-repeat"
			:style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username  + '@' + this.$common.currentTime()+'@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,
			}
		},
		created() {
			this.getConfig()
		},
		methods: {
			getConfig() {
				this.$api.config({
					watermark: '水印'
				}).then((res) => {
					console.log("res");
					console.log(res);
				}).catch((error) => {
					console.log(error.msg);
					
				})
			}

		}
	}
</script>

<style>
</style>